import {
  computed,
  IObservableArray,
  makeAutoObservable,
  observable,
} from "mobx";
import { StudentWithGroupsResponseApi } from "../../DTO/ServerResponseType/Student/StudentWithGroups";
import studentServerClient from "../../ServerClients/StudentServerClient";
import Fuse from "fuse.js";
import { GroupWindowStore } from "./GroupWindowStore";

const fuseOptions = {
  isCaseSensitive: false,
  shouldSort: false,
};

let fuseStudentName: Fuse<StudentWithGroupsResponseApi> = new Fuse([], {
  ...fuseOptions,
  keys: ["studentName"],
});

export class StudentsStore {
  root: GroupWindowStore;
  students: IObservableArray<StudentWithGroupsResponseApi> = observable.array(
    []
  );
  searchPattern: string = "";

  constructor(root: GroupWindowStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  onChangeSearchPattern = (searchPattern: string) => {
    this.searchPattern = searchPattern;
  };

  @computed
  get searchedStudentWithoutGroupStudents(): StudentWithGroupsResponseApi[] {
    let newStudents: StudentWithGroupsResponseApi[] = JSON.parse(
      JSON.stringify(this.students)
    );

    newStudents = newStudents.filter((student) =>
      !this.root.group.groupStudents.find(
        (groupStudent) => groupStudent.student.studentId === student.studentId
      )
    );

    if (this.searchPattern !== "") {
      fuseStudentName.setCollection(newStudents);
      newStudents = fuseStudentName
        .search(this.searchPattern)
        .map(({ item }) => item);
    }

    return newStudents ? newStudents : [];
  }

  loadAllStudentsAsync = async (): Promise<
    StudentWithGroupsResponseApi[] | never
  > => {
    return await studentServerClient
      .sendToGetAllStudentsAsync()
      .then((students) => {
        this.students.replace(students);
        return students;
      });
  };
}
